import Vue from "vue";
import Router from "vue-router";
import aboutus from "./views/aboutus.vue";
import contactus from "./views/contactus.vue";
import home from "./views/Home.vue";
import joinus from "./views/joinus.vue";
import minelink from "./views/minelink.vue";
import news from "./views/news.vue";
import projectcase from "./views/projectcase.vue";
import solution from "./views/solution";
import newsdetail from "./views/newsdetail";
Vue.use(Router);
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: home
    },
    {
      // 关于大蔚
      path: "/aboutus",
      name: "aboutus",
      component: aboutus
    },
    {
      // 解决方案
      path: "/solution",
      name: "solution",
      component: solution
    },
    {
      // 项目案例
      path: "/projectcase",
      name: "projectcase",
      component: projectcase
    },
    {
      // 新闻资讯
      path: "/news",
      name: "news",
      component: news
    },
    {
      // 人才中心
      path: "/newsdetail",
      name: "newsdetail",
      component: newsdetail
    },
    {
      // 人才中心
      path: "/joinus",
      name: "joinus",
      component: joinus
    },
    {
      // 联系方式
      path: "/contactus",
      name: "contactus",
      component: contactus
    },
    {
      // 友情链接
      path: "/minelink",
      name: "minelink",
      component: minelink
    },
    {
      path: "*",
      name: "default",
      redirect: "/home",
      component: home
    }
  ]
});
